export default {
  methods: {
    datepickerInit(input, opts = {}) {
      initDatepicker(input, opts);
    },
    datepickerAllowedDates(input, excursion, where, useSource, getAllowedDaysWeek, checkAllowedDates, getExcludedDates, getIncludedDates, getDateRange, getIsPeriodic, hasPeriodByDateRange) {
      if(!input.datepicker) {
        // если datepicker не инициализирован то нам делать нечего
        return;
      }
      const highlightedDisabled = false;
      const todayMoment = moment();
      input.datepicker.update({
        onRenderCell ({date, cellType, datepicker}) {
          // функция проверки доступности дат
          if (cellType !== 'day') {
            // если календарь показывает не дни - ничего не делаем
            return {};
          }
          let currentDate = moment(date);
          let allowedDatesActive = typeof where === 'function' ? where() : where;
          let allowedDaysWeek = getAllowedDaysWeek(excursion);
          if (getIsPeriodic(excursion)) {
            // если экскурсия периодичная - игнорируем дни недели
            allowedDaysWeek = [];
          }
          if(moment(window._GLOBAL_LIMITATIONS.EXCLUDE_DATE_ORDER, 'YYYY-MM-DD').unix() >= currentDate.unix() &&
            moment(window._GLOBAL_LIMITATIONS.INCLUDE_DATE_ORDER, 'YYYY-MM-DD').unix() !== currentDate.unix()) {
            // проверка на глобально недоступных дат в .env
            // console.log('?1', date);
            return {
              disabled: true,
              classes: highlightedDisabled && allowedDaysWeek.indexOf(date.getDay()) !== -1 ? '-highlighted-' : '',
            };
          }
          if(_.ceil(currentDate.diff(todayMoment, 'days', true)) <= 0) {
            // даты до 'сегодня' включительно не доступны для заказа
            // console.log('?2', date);
            return {
              disabled: true,
              classes: highlightedDisabled && allowedDaysWeek.indexOf(date.getDay()) !== -1 ? '-highlighted-' : '',
            };
          }
          if(todayMoment.hour() >= +_.get(_.find(window._APP_PARAMS.tourClosingTime, ['day_number', todayMoment.day()+1]), 'time_on') &&
            _.ceil(currentDate.diff(todayMoment, 'days', true)) === 1) {
            // 'завтра' не доступно для заказа если до закрытия тура осталось менее суток(?)
            // console.log('?3', date);
            return {
              disabled: true,
              classes: highlightedDisabled && allowedDaysWeek.indexOf(date.getDay()) !== -1 ? '-highlighted-' : '',
            };
          }
          if(!checkAllowedDates(excursion)) {
            // если мы ещё не получили доступные даты то далаем всё недоступным
            // console.log('?4', date);
            return {
              disabled: false,
              classes: highlightedDisabled && allowedDaysWeek.indexOf(date.getDay()) !== -1 ? '-highlighted-' : '',
            };
          }
          let timeDaysWeek = _.get(excursion, 'timeCollection.time_days_week');
          if(_.isArray(timeDaysWeek) && timeDaysWeek.length > 0 && _.findIndex(timeDaysWeek, ['day_number', currentDate.day()+1]) === -1) {
            // проверяем доступность точки стыковки для текущего дня недели
            // console.log('?5', date);
            return {
              disabled: true,
              classes: highlightedDisabled && allowedDaysWeek.indexOf(date.getDay()) !== -1 ? '-highlighted-' : '',
            };
          }
          let orderLimit = _.find(_.get(excursion, 'closeToOrderLimits', []), ['date_at', currentDate.format('YYYY-MM-DD')]);
          if(orderLimit && orderLimit.possible <= 0) {
            // если достигнут предел заказов - делаем недоступной дату
            // console.log('?6', date);
            return {
              disabled: true,
              classes: highlightedDisabled && allowedDaysWeek.indexOf(date.getDay()) !== -1 ? '-highlighted-' : '',
            };
          }
          if(getExcludedDates(allowedDatesActive, useSource ? _.get(excursion, 'dates', []) : null).indexOf(currentDate.format('YYYY-MM-DD')) !== -1) {
            // если дата в исключённых
            // console.log('?7', date, getExcludedDates(allowedDatesActive, useSource ? _.get(excursion, 'dates', []) : null));
            return {
              disabled: true,
              classes: highlightedDisabled && allowedDaysWeek.indexOf(date.getDay()) !== -1 ? '-highlighted-' : '',
            };
          }
          if(getIncludedDates(allowedDatesActive, useSource ? _.get(excursion, 'dates', []) : null).indexOf(currentDate.format('YYYY-MM-DD')) !== -1) {
            // если дата во включённых
            // console.log('?8', date, getIncludedDates(allowedDatesActive, useSource ? _.get(excursion, 'dates', []) : null));
            return {
              disabled: false,
              classes: '-highlighted-'
            };
          }
          const dateRange = getDateRange(allowedDatesActive, useSource ? _.get(excursion, 'dates', []) : null);
          if(dateRange) {
            // проверяем период дат и если не попадает - выключаем
            const dateRangeStart = moment(_.get(dateRange, 'date_start'), 'YYYY-MM-DD');
            const dateRangeEnd = moment(_.get(dateRange, 'date_end'), 'YYYY-MM-DD');
            if (!currentDate.isBetween(dateRangeStart, dateRangeEnd, 'days', '[]')) {
              // console.log('?9', date, dateRange);
              return {
                disabled: true,
                classes: highlightedDisabled && allowedDaysWeek.indexOf(date.getDay()) !== -1 ? '-highlighted-' : '',
              };
            }
          }
          if(getIsPeriodic(excursion)) {
            // если периодичная
            // console.log('?10', date, hasPeriodByDateRange(currentDate, allowedDatesActive, useSource ? _.get(excursion, 'period') : null));
            let tourDate = hasPeriodByDateRange(currentDate, allowedDatesActive, useSource ? _.get(excursion, 'period') : null);
            return {
              disabled: !tourDate,
              classes: highlightedDisabled && tourDate ? '-highlighted-' : '',
            };
          }
          if(allowedDaysWeek.indexOf(date.getDay()) !== -1) {
            // если дата попадает на доступный день недели
            // console.log('?11', date);
            return {
              disabled: false,
              classes: highlightedDisabled || currentDate.unix() >= todayMoment.unix() ? '-highlighted-' : '',
            };
          }
          // вcё остальное - недоступно
          // console.log('?12', date, allowedDaysWeek);
          return {
            disabled: true,
          };
        },
      });
    },
  }
};
